/* eslint-disable tailwindcss/no-custom-classname */
import { useRouter } from 'next/router'
import useSWR from 'swr'
import { GetCommentResponse } from '@/types/comment'
import { MemberComment, RoundedButton } from './'

import { useState, useEffect } from 'react'
import { useNiceClipAction } from '@/hooks/useNiceClipAction'

interface Props {
  summaryId: number
}

export const MemberCommentList: React.FC<Props> = ({ summaryId }) => {
  const router = useRouter()
  const { data } = useSWR<GetCommentResponse>(
    `/api//summary/pickup/${summaryId}?page=1&limit=3`
  )
  const { comments, onClickAction } = useNiceClipAction(
    data && data.result ? data.comments : []
  )
  const [total, setTotal] = useState<number>(0)

  useEffect(() => {
    if (data && data.result) {
      setTotal(data.total)
    } else {
      setTotal(0)
    }
  }, [data])

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    router.push(`/summary/comments/${summaryId}`)
  }

  if (!data || !data.result || data.comments.length === 0) return null

  return (
    <>
      <div className="flex mb-[30px] w-full border-t border-[#e6e6e6] border-solid">
        <div className="relative mx-auto mt-[30px] mb-0 sm:mb-5 min-h-[50px] font-medium text-center">
          <div className="text-2xl leading-6 text-black">
            <span className="text-center shadow-[inset_0_-9px_0_0_#dcecf8]">
              注目の学びメモ
            </span>
          </div>
        </div>
      </div>
      {comments.map((comment, i) => {
        return (
          <div key={`comment-${i}`} className="px-5">
            <MemberComment comment={comment} onActionClick={onClickAction} />
          </div>
        )
      })}
      {total > 3 && <RoundedButton text="もっと見る" onClick={onClick} />}
    </>
  )
}
